export enum InviteeType {
  Group = "Group",
  Individual = "Individual",
  /** A member attending a single occurrence only — not on the plan roster. */
  OneOff = "OneOff",
}
